interface IntroStepProps {
  onStart: () => void
}

export function IntroStep({ onStart }: IntroStepProps) {
  return (
    <section className="wtta-step wtta-step--intro" data-testid="intro-step">
      <h2 className="wtta-title">WTTA Readiness Quickscan</h2>
      <p className="wtta-lead">
        In ongeveer twee minuten weet je hoe goed jouw organisatie er voor staat
        voor de Wet Toelating Terbeschikkingstelling van Arbeidskrachten.
      </p>
      <ul className="wtta-bullets">
        <li>7 vragen, geen registratie vooraf</li>
        <li>Direct jouw readiness-score in beeld</li>
        <li>Persoonlijk rapport met aanbevelingen en 90-dagen planning per e-mail</li>
      </ul>
      <button type="button" className="wtta-button wtta-button--primary" onClick={onStart}>
        Start de quickscan
      </button>
    </section>
  )
}
